<script setup>


import { getAuth, onAuthStateChanged } from "firebase/auth";
import { onBeforeUnmount, ref } from 'vue';
import { LOGIN_PATH } from "./env";
import { Firebase_App } from "./firebase";

const user = ref(null)

let unsubscribe;

onBeforeUnmount(() => {
  unsubscribe && unsubscribe()
});

// make it so the suspense handles loading first auth status   
async function loadAuth() {

  return new Promise((resolve, reject) => {
    let initialized = false;
    unsubscribe = onAuthStateChanged(getAuth(Firebase_App), newUser => {        
      if (!newUser) {        
        window.location = LOGIN_PATH;        
      }
      user.value = newUser
      if (!initialized) {
        initialized = true
        resolve(newUser)
      }
    })

  })
}
await loadAuth();

</script>

<template>
  <div v-if="!user">loading user info</div>
  <div v-else-if="!user.emailVerified">Please verify your email {{ user.email }}. Once done, reload the plage.</div>
  <slot v-else :key="user.uid" />    
</template>

